import { ExtendedAttribute } from './extended-attribute';

export class ExtendedAttributeTranslationsCommand {
    'translation_en-GB': string;
    'translation_de-DE': string;
    'translation_fr-FR': string;
    'translation_it-CH': string;

    constructor(model: ExtendedAttribute) {
        this['translation_en-GB'] = model['translation_en-GB'];
        this['translation_de-DE'] = model['translation_de-DE'];
        this['translation_fr-FR'] = model['translation_fr-FR'];
        this['translation_it-CH'] = model['translation_it-CH'];
    }
}
